import { CustomerAgeStatus, getCustomerAgeStatus } from './age'

export const isCustomerAdult = (dateOfBirth?: string | null) => {
  const ageStatus = getCustomerAgeStatus(dateOfBirth)

  if (ageStatus === CustomerAgeStatus.adult) return 1
  if (ageStatus === CustomerAgeStatus.underage) return 0

  return undefined
}

export const getDatalayerPhoneNumber = (phoneNumber: string) => {
  const phonePrefix = '+48'

  return `${phonePrefix}${phoneNumber}`
}
